import { render, staticRenderFns } from "./PgaOfferEvaluationTotalCostsPresaleDetails.vue?vue&type=template&id=32b0fb59&"
import script from "./PgaOfferEvaluationTotalCostsPresaleDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalCostsPresaleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b0fb59')) {
      api.createRecord('32b0fb59', component.options)
    } else {
      api.reload('32b0fb59', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalCostsPresaleDetails.vue?vue&type=template&id=32b0fb59&", function () {
      api.rerender('32b0fb59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationTotalCostsPresaleDetails.vue"
export default component.exports